import { createSlice } from "@reduxjs/toolkit";

import { fetchFeedback } from "./asyncActions";
import { IFeedbackState } from "./types";

const initialState: IFeedbackState = {
  isOpen: false,
  isOpenSuccessModal: false,
};

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    openFeedbackModal(state) {
      state.isOpen = true;
    },
    closeFeedbackModal(state) {
      state.isOpen = false;
      state.isOpenSuccessModal = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchFeedback.pending, (state) => {
      state.isOpen = false;
    })
    .addCase(fetchFeedback.fulfilled, (state) => {
      state.isOpen = false;
      state.isOpenSuccessModal = true;
    })
    .addCase(fetchFeedback.rejected, (state) => {
      state.isOpen = false;
    })
  },
});

export const { openFeedbackModal, closeFeedbackModal } = feedbackSlice.actions;

export default feedbackSlice.reducer;
